var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30833 8.33341C1.95 8.33341 1.66666 8.05008 1.66666 7.69175V5.76675C1.66666 3.50841 3.50833 1.66675 5.76666 1.66675H7.69166C8.05 1.66675 8.33333 1.95008 8.33333 2.30841C8.33333 2.66675 8.05 2.95008 7.69166 2.95008H5.76666C4.20833 2.95008 2.95 4.21675 2.95 5.76675V7.69175C2.95 8.05008 2.65833 8.33341 2.30833 8.33341Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6917 8.33341C17.3417 8.33341 17.05 8.05008 17.05 7.69175V5.76675C17.05 4.20841 15.7833 2.95008 14.2333 2.95008H12.3083C11.95 2.95008 11.6667 2.65841 11.6667 2.30841C11.6667 1.95841 11.95 1.66675 12.3083 1.66675H14.2333C16.4917 1.66675 18.3333 3.50841 18.3333 5.76675V7.69175C18.3333 8.05008 18.05 8.33341 17.6917 8.33341Z",
    fill: "#CCCFD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2333 18.3333H13.075C12.725 18.3333 12.4333 18.05 12.4333 17.6917C12.4333 17.3417 12.7167 17.05 13.075 17.05H14.2333C15.7917 17.05 17.05 15.7833 17.05 14.2333V13.0833C17.05 12.7333 17.3333 12.4417 17.6917 12.4417C18.0417 12.4417 18.3333 12.725 18.3333 13.0833V14.2333C18.3333 16.4917 16.4917 18.3333 14.2333 18.3333Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69166 18.3334H5.76666C3.50833 18.3334 1.66666 16.4917 1.66666 14.2334V12.3084C1.66666 11.9501 1.95 11.6667 2.30833 11.6667C2.66666 11.6667 2.95 11.9501 2.95 12.3084V14.2334C2.95 15.7917 4.21666 17.0501 5.76666 17.0501H7.69166C8.04166 17.0501 8.33333 17.3334 8.33333 17.6917C8.33333 18.0501 8.05 18.3334 7.69166 18.3334Z",
    fill: "#838B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3833 9.3584H14.25H5.75H4.61667C4.25833 9.3584 3.975 9.65007 3.975 10.0001C3.975 10.3501 4.25833 10.6417 4.61667 10.6417H5.75H14.25H15.3833C15.7417 10.6417 16.025 10.3501 16.025 10.0001C16.025 9.65007 15.7417 9.3584 15.3833 9.3584Z",
    fill: "#838B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.6167V11.8917C5.75 13.275 6.86667 14.3917 8.25 14.3917H11.75C13.1333 14.3917 14.25 13.275 14.25 11.8917V11.6167C14.25 11.5167 14.175 11.4417 14.075 11.4417H5.925C5.825 11.4417 5.75 11.5167 5.75 11.6167Z",
    fill: "#838B9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.3834V8.1084C5.75 6.72506 6.86667 5.6084 8.25 5.6084H11.75C13.1333 5.6084 14.25 6.72506 14.25 8.1084V8.3834C14.25 8.4834 14.175 8.5584 14.075 8.5584H5.925C5.825 8.5584 5.75 8.4834 5.75 8.3834Z",
    fill: "#CCCFD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.ea2ad4a191d01865d5223738f9418d27.svg";
export { ForwardRef as ReactComponent };